import SettingsPage from './pages/Settings.page'
import SchedulePage from './pages/Schedule.page';

SettingsPage.path = '/settings';
SchedulePage.path = '/settings/schedule/:id?';

export default {
  pages: {
    SettingsPage,
    SchedulePage,
  }
};
